// "Det finns ingen lagerplats HA-1-2-3. Närmast finns HA-1-2-1 och HA-1-2-2." (owner 2026-11-04): a code that looks
// like a location but is not one gets told so, with the places that do exist nearby, instead of the general
// "neither a location nor a pallet" message.

import { t } from "../i18n.js";
import { nearLocations, type Registry } from "./registry.js";

/** At most this many nearby places are named; more are shown as a range. */
const LIST_MAX = 4;

export function missingLocationMessage(reg: Registry, text: string): string | null {
  const near = nearLocations(reg, text);
  if (!near) return null;
  const code = text.trim().toUpperCase().replace(/\+/g, "-").slice(0, 40);
  if (near.codes.length > LIST_MAX) return t("loc.missingRange", { code, prefix: near.prefix, first: near.codes[0]!, last: near.codes[near.codes.length - 1]! });
  const list = near.codes.length === 1 ? near.codes[0]! : `${near.codes.slice(0, -1).join(", ")} ${t("loc.and")} ${near.codes[near.codes.length - 1]}`;
  return t("loc.missingNear", { code, near: list });
}
